import { useQuery } from "@apollo/client";

import { GetSubscriptionQuery, GetSubscriptionQueryVariables } from "@ctypes";
import { GET_SUBSCRIPTION } from "@graphql";

export const useSubscription = () => {
  const { data: queryData, ...rest } = useQuery<
    GetSubscriptionQuery,
    GetSubscriptionQueryVariables
  >(GET_SUBSCRIPTION);

  const data = queryData?.getSubscription;

  return { data, ...rest };
};
